import React from "react";
import { Link } from "react-router-dom";
import {
  Brain,
  HeartPulse,
  SmilePlus,
  Dna,
  Video,
  Globe,
  Biohazard,
  Radiation,
  Star,
  User,
  BookOpen,
  Stethoscope,
  PackageSearch,
  Rocket
} from "lucide-react";
import { banner_style } from "../Styles/styles";

const data = {
  event: {
    title: "About Us",
    date: "Feb 22-23 | 2027",
    organizer: "Helix Conferences",
    description: [
      <>
        Step into the world of innovation and excellence at the International Engineering and Technology Summit in Osaka, Japan. This premier event unites engineers, technologists, industry pioneers, and researchers to explore the latest breakthroughs and emerging trends across multiple disciplines. Our goal is to inspire collaboration, ignite innovation, and drive meaningful progress in engineering and technology.
      </>,
      <>
        From cutting-edge AI to advanced robotics, from cybersecurity trends to sustainable engineering—we curate thought-provoking content and create immersive spaces where innovation thrives. Explore our sessions to engage with the future of technology, exchange ideas with global experts, and drive impactful solutions across industries.{" "}
        <Link
          to="/Quantumtech-conference-tracks/"
          target="blank"
          rel="noopener noreferrer"
          className="text-accent font-bold"
        >

        </Link>{" "}

      </>,
    ],
  },




  join: [
    "Join us at the 2026 QUANTUMTECH Summit to experience the fusion of technology, innovation, and real-world impact. Be part of the conversations that are transforming digital solutions, automation, and intelligent systems at scale"
  ],



  highlights: [
    {
      title: "Keynote Speakers",
      description: "Tech leaders, innovators, and entrepreneurs share expert insights on emerging technologies and industry trends",
    },
    {
      title: "Panel Discussions",
      description: "Debates and discussions on AI, digital transformation, tech ethics, and future innovation",
    },
    {
      title: "Live Demonstrations",
      description: "See cutting-edge software, AI tools, robotics, and tech solutions in action",
    },
    {
      title: "Innovation Labs",
      description: "Hands-on experience with new technologies, prototypes, and startup solutions",
    },
    {
      title: "Poster Presentations",
      description: "Showcase research findings, tech projects, and innovative ideas from academia and startups",
    },
    {
      title: "Workshops",
      description: "Practical training on AI, machine learning, software development, cloud computing, and more",
    },
    {
      title: "Partnership Zones",
      description: "Connect with tech brands, investors, and potential collaborators for strategic partnerships",
    },
    {
      title: "Awards & Recognition",
      description: "Celebrate excellence in technology, innovation, and entrepreneurial achievements",
    },
  ],


  dates: {
    eventDate: "Feb 22-23 | 2027",
    venue: "Novotel Valencia, Spain",
    registrationDeadline: "1st Feb 2027",
  },
};


const AboutPublicHealth = () => {
  return (
    <div className="w-full  mx-auto justify-center items-center text-center">
      <div
        className={`${banner_style} w-full mx-auto about-banner`}
        style={{
          backgroundImage: "url('https://images.unsplash.com/photo-1531545514256-b1400bc00f31?fm=jpg&q=60&w=3000&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxzZWFyY2h8M3x8YWJvdXQlMjB1c3xlbnwwfHwwfHx8MA%3D%3D')",
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
        }}
      >
        <h2 className="text-slate-100 text-3xl sm:text-5xl md:text-6xl font-bold px-4 z-10">
          {data.event.title}
        </h2>
      </div>

      <div className="bg-gray-50 rounded-3xl p-8 md:p-12 shadow-sm my-12 max-w-6xl mx-auto border border-gray-100">
        <h1 className="text-3xl md:text-5xl font-bold text-one mb-4 tracking-tight">
          A CONFERENCE ON QUANTUMTECH-2027
        </h1>

        <div className="flex justify-center mb-8">
          <div className="inline-flex items-center gap-2 bg-white px-6 py-2 rounded-full shadow-sm border border-gray-200 text-gray-700 font-medium text-lg">
            <span>📅</span>
            <span>Feb 22-23 | 2027</span>
          </div>
        </div>

        {data.event.description.map((desc, idx) => (
          <p
            key={idx}
            className="mb-6 text-lg leading-relaxed text-slate-700 text-justify w-full max-w-4xl mx-auto"
          >
            {desc}
          </p>
        ))}
      </div>



      {/* Join Section */}
      <section className="mb-10 text-center w-full max-w-5xl mx-auto px-2 md:px-12 lg:px-24">
        <h2 className="text-3xl font-bold text-one mb-4 w-full">
          Join the Global Community at  QUANTUMTECH Conference 2026
        </h2>
        {data.join.map((para, idx) => (
          <p
            key={idx}
            className="mb-6 text-lg leading-relaxed text-justify w-full max-w-5xl mx-auto px-2 md:px-12 lg:px-24"
          >
            {para}
          </p>
        ))}
      </section>

      {/* Themes Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl my-8 font-bold text-one">Who Can Attend...</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-6">
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <User className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              IT Professionals & Software Developers
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <BookOpen className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Academics & Researchers
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <Rocket className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Tech Entrepreneurs & Startups
            </h3>
          </div>
          <div className="bg-white rounded-xl shadow px-4 py-6 flex flex-col items-center hover:shadow-lg transition">
            <PackageSearch className="h-10 w-10 text-one mb-3" />
            <h3 className="text-lg font-semibold text-gray-800 mb-1">
              Business & Technology Consultants
            </h3>
          </div>

        </div>
      </section>

      {/* Highlights Section */}
      <section className="mb-16 text-center w-full px-12">
        <h2 className="text-4xl font-bold text-one mb-8">Event Highlights</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 w-full items-start">
          {data.highlights.map((highlight, idx) => (
            <div
              key={idx}
              className="bg-white rounded-xl p-4 text-md text-gray-800 text-left flex items-start shadow-sm "
            >
              <Star className="w-4 h-4 text-yellow-500 fill-yellow-500 mr-3 mt-1" />
              <div className="flex flex-wrap items-start">
                <h3 className="font-semibold whitespace-nowrap mr-1">
                  {highlight.title} –
                </h3>
                <p className="text-md text-gray-600 flex-1">
                  {highlight.description}
                </p>
              </div>
            </div>
          ))}
        </div>
      </section>

      {/* Dates Section */}
      {/* <section className="mb-16 text-center w-full md:px-12 px-4">
        <h2 className="text-4xl font-bold text-one mb-8">
          Important Dates
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 w-full text-sm">
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Calendar className="w-6 h-6 text-one mb-2" />
            <strong>Event Date</strong>
            <p>{data.dates.eventDate}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <Globe className="w-6 h-6 text-one mb-2" />
            <strong>Proposed Venue</strong>
            <p>{data.dates.venue}</p>
          </div>
          <div className="bg-white rounded-xl shadow p-4 flex flex-col items-center">
            <BadgeCheck className="w-6 h-6 text-one mb-2" />
            <strong>Registration Deadline</strong>
            <p>{data.dates.registrationDeadline}</p>
          </div>
        </div>
      </section> */}
    </div>
  );
};

export default AboutPublicHealth;

